import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';

import { QueryVariables } from 'queries/types';

import { accountTicketsGenerating } from './queries';

export const useAccountGeneratingTickets = (
  variables: QueryVariables<typeof accountTicketsGenerating> = {},
  config: Partial<ReturnType<typeof accountTicketsGenerating>> = {},
) => {
  const { isSignedIn } = useAuth();

  const query = useQuery({
    ...accountTicketsGenerating(variables),
    retry: false,
    ...config,
    enabled: !!isSignedIn && config.enabled,
  });

  return {
    generatingTickets: !!query.data?.generatingTickets,
    status: query.status,
  };
};
